// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ICompilationTypeTermFieldSchema {
  /** Тип поля **/
  type: EType;
  /** Тип подборки **/
  value: EValue;
}

export enum EType {
  /** Поле с одним значением **/
  'Term' = 'term',
  /** Поле со списком значений **/
  'Terms' = 'terms',
}
export enum EValue {
  /** Последний шанс купить со скидкой **/
  'LastChanceDiscount' = 'lastChanceDiscount',
  /** Топ акций **/
  'TopPromos' = 'topPromos',
}
